<template>
<a-spin :spinning="spinning" tip="Loading...">
    <div class="card mb-3">
        <div class="row no-gutters">
            <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-7 align-self-center">
                            <div v-if="reportDescription != ''" class="card">
                                <div class="card-body">
                                    <div class="card-text">
                                        {{ reportDescription }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <base-input label="Site Selection" class="col-md-6">
                            <a-select mode="multiple" style="width: 100%" placeholder="Please select" optionFilterProp="children"  v-model="selectedSiteId" :disabled="site_type != 'ho'">
                                <a-select-option v-for="site in validSites" :key="site.id" :value="site.id">{{site.name}}</a-select-option>
                            </a-select>
                        </base-input>
                        <base-input label="Date Range" class="col-md-6">
                            <br><a-range-picker @change="onDateFilter" :format="dateFormat" input-classes="form-control" style="width: 100%"/>
                        </base-input>
                        <base-input label="Cashier" class="col-md-6">
                            <a-select style="width: 100%" placeholder="Please select cashier" optionFilterProp="children"  v-model="selectedCashierId">
                                <a-select-option value="0">All Cashiers Per Terminal</a-select-option>
                                <a-select-option value="-1">All Cashiers Per Total</a-select-option>
                                <a-select-option v-for="cashier in validCashiers" :key="cashier.id" :value="cashier.id">{{cashier.first_name}} {{cashier.last_name}}</a-select-option>
                            </a-select>
                        </base-input>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <br>
                            <download-excel
                                worksheet="Sales Reports"
                                :name="excelFileName"
                                type="xlsx"
                                :fetch="excelData"
                                :fields="excelHeaders">
                                <button class="btn btn-sm btn-success float-right ml-2"
                                        style="border-radius: 24px; border:0px; width: 20%;">
                                    Generate Report in Excel
                                </button>
                            </download-excel>

                            <button class="btn btn-sm btn-default float-right"
                                    style="border-radius: 24px; border:0px; width: 20%;"
                                    @click.prevent="generateReport">
                              Generate Report in PDF
                            </button> &nbsp; &nbsp;
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</a-spin>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage';
    import moment from 'moment';
    import jsPDF from 'jspdf';
    import 'jspdf-autotable';
    import { getReportDescription } from '../../utilities';

    const fs = require('fs')

    function formatNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    }

    import {
        mapState
    } from 'vuex'

    export default {
        data() {
          return {
            spinning: false,
            selectedSiteId: [],
            site_type: "ho",
            selectedCashierId: "0",
            dateFormat: 'YYYY-MM-DD',
            dateFormat2: 'YYYY-MM-DD hh:mm a',
            validSites: null,
            validCashiers: null,
            dateFilter: null,
            dateFilter2: null,
            excelFileName: `POS_Cashier_Accountability_Report_${moment().format('YYYY_MM_DD_HH_mm_ss')}`,
            excelHeaders: {
              "Date Range": 'dateRange',

              "Site": "site",
              "Cashier Name": "cashierName",
              "Vatable Sales": "vatableSales",
              "VAT Amount": "vatAmount",
              "VAT-Exempt Sales": "vatExemptSales",
              "Zero-Rated Sales": "zeroRatedSales",
              "Gross Sales": "grossSales",

              "Regular Discounts (Deductions)": "regularDiscountDeductions",
              "Special 5% Discounts (Deductions)": "special5DiscountDeductions",
              "Special 20% Discounts (Deductions)": "special20DiscountDeductions",
              "Returns (Deductions)": "returnDeductions",
              "Voids (Deductions)": "voidsDeductions",
              "Manual (Deductions)": "manualDeductions",
              "Total Deductions": "totalDeductions",

              "Regular Discounts (VAT Adjustments)": "regularDiscountAdjusments",
              "Special 5% Discounts (VAT Adjustments)": "special5DiscountAdjusments",
              "Special 20% Discounts (VAT Adjustments)": "special20DiscountAdjusments",
              "Returns (VAT Adjustments)": "returnAdjusments",
              "Voids (VAT Adjustments)": "voidsAdjusments",
              "Manual (VAT Adjustments)": "manualAdjusments",
              "Total VAT Adjustments": "totalVatAdjustments",

              "Excess GC": "excessGC",
              "Excess RS": "excessRS",
              "Other Income": "otherIncome",

              "+ Deposit": "deposit",
              "+ Payments": "payments",
              "- Withdrawal": "withdrawal",
              "Amount in Drawer": "amountInDrawer",

              "Net Sales": "netSales",
              "Net VAT Amount": "netVatAmount",
              "Total Quantity": "totalQuantity",
            },
            reportDescription: ''
          }
        },
        mounted: async function () {
            var userId = secureStorage.getItem("userId")
            var site_data = await HTTPRequest.getRequest(this.endPoint + 'sites/get_valid_sites?user_id=' + userId, null)
            this.validSites = site_data

            var cashier_data = await HTTPRequest.getRequest(this.endPoint + 'users/get_valid_cashiers', null)
            this.validCashiers = cashier_data
            this.reportDescription = await getReportDescription(this.currentProfile)

            let siteId = secureStorage.getItem("defaultSiteId")
            this.selectedSiteId = [siteId]

            let site = await HTTPRequest.getRequest(this.endPoint + "/sites/" + siteId, null)
            if(site != undefined){
                this.site_type = site.site_type
            }
        },
        computed: {
            ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters']),
        },
        methods: {
            moment,
            openNotificationWithIcon(type, msg) {
              if(type == 'error'){
                this.$notification[type]({
                  message: 'Export Error',
                  description: msg
                });
              }else if(type == 'warning'){
                this.$notification[type]({
                  message: 'No Data Found',
                  description: msg
                });
              }
            },
            onDateFilter(date, dateString) {
              this.searchDateFrom = dateString[0]
              this.searchDateTo = dateString[1]
            },
            async excelData() {
               this.spinning= true;
            if(this.selectedSiteId.length == 0){
                this.openNotificationWithIcon('error', 'Please select site.');
                this.spinning= false;
                return
            }

            if(this.searchDateFrom == '' || this.searchDateTo == '' || this.searchDateFrom == undefined || this.searchDateTo == undefined){
                this.openNotificationWithIcon('error', 'Please date.');
                this.spinning= false;
                return
            }
              let jsonData = [];

              var request = await HTTPRequest.getRequest(this.endPoint + 'x_readings/pos_cashier_accountability_report?from=' + this.searchDateFrom + "&to=" + this.searchDateTo + "&site_ids=" + this.selectedSiteId + "&user_id=" + this.selectedCashierId, null)

              const reportDetails = request.report_details;

              if (reportDetails.length == 0) {
                this.openNotificationWithIcon('warning', 'Try increasing the scope by adjusting the filters.');
                this.spinning= false;
                return;
              }

              reportDetails.map(detail => {
                jsonData.push({
                  dateRange: `${this.searchDateFrom} to ${this.searchDateTo}`,
                  site: detail.site_name,
                  cashierName: detail.cashier_name,
                  vatableSales: formatNumber(parseFloat(detail.vatable_sales).toFixed(2)),
                  vatAmount: formatNumber(parseFloat(detail.vat_amount).toFixed(2)),
                  vatExemptSales: formatNumber(parseFloat(detail.vat_exempt_sales).toFixed(2)),
                  zeroRatedSales: formatNumber(parseFloat(detail.zero_rated_sales).toFixed(2)),
                  grossSales: formatNumber(parseFloat(detail.gross_sales).toFixed(2)),

                  regularDiscountDeductions: formatNumber(parseFloat(detail.regular_discount).toFixed(2)),
                  special5DiscountDeductions: formatNumber(parseFloat(detail.special_5).toFixed(2)),
                  special20DiscountDeductions: formatNumber(parseFloat(detail.special_20).toFixed(2)),
                  returnDeductions: formatNumber(parseFloat(detail.returns).toFixed(2)),
                  voidsDeductions: formatNumber(parseFloat(detail.voids).toFixed(2)),
                  manualDeductions: formatNumber(parseFloat(detail.manual).toFixed(2)),
                  totalDeductions: formatNumber(parseFloat(detail.deductions).toFixed(2)),

                  regularDiscountAdjusments: formatNumber(parseFloat(detail.va_regular_discount).toFixed(2)),
                  special5DiscountAdjusments: formatNumber(parseFloat(detail.va_special_5).toFixed(2)),
                  special20DiscountAdjusments: formatNumber(parseFloat(detail.va_special_20).toFixed(2)),
                  returnAdjusments: formatNumber(parseFloat(detail.va_returns).toFixed(2)),
                  voidsAdjusments: formatNumber(parseFloat(detail.va_voids).toFixed(2)),
                  manualAdjusments: formatNumber(parseFloat(detail.va_manual).toFixed(2)),
                  totalVatAdjustments: formatNumber(parseFloat(detail.va_total).toFixed(2)),

                  excessGC: formatNumber(parseFloat(detail.excess_gc).toFixed(2)),
                  excessRS: formatNumber(parseFloat(detail.excess_rs).toFixed(2)),
                  otherIncome: formatNumber(parseFloat(detail.other_income_total).toFixed(2)),

                  deposit: formatNumber(parseFloat(detail.deposit).toFixed(2)),
                  payments: formatNumber(parseFloat(detail.payments).toFixed(2)),
                  withdrawal: formatNumber(parseFloat(detail.withdrawal).toFixed(2)),
                  amountInDrawer: formatNumber(parseFloat(detail.amount_in_drawer).toFixed(2)),

                  netSales: formatNumber(parseFloat(detail.net_sales).toFixed(2)),
                  netVatAmount: formatNumber(parseFloat(detail.net_vat_amount).toFixed(2)),
                  totalQuantity: formatNumber(parseFloat(detail.total_quantity).toFixed(2)),
                })
              })

              this.excelFileName = `POS_Cashier_Accountability_Report_${moment().format('YYYY_MM_DD_HH_mm_ss')}`
              this.spinning= false;
              return jsonData;
            },
            async generateReport(){
                if(this.selectedSiteId.length == 0){
                    this.openNotificationWithIcon('error', 'Please select site.');
                    this.spinning= false;
                    return
                }
                if(this.searchDateFrom == '' || this.searchDateTo == '' || this.searchDateFrom == undefined || this.searchDateTo == undefined){
                    this.openNotificationWithIcon('error', 'Please date.');
                    this.spinning= false;
                    return
                }
                this.spinning= true;
                var queryResult = await HTTPRequest.getRequest(this.endPoint + 'x_readings/pos_cashier_accountability_report?from=' + this.searchDateFrom + "&to=" + this.searchDateTo + "&site_ids=" + this.selectedSiteId + "&user_id=" + this.selectedCashierId, null)
                this.posCashierAccountability = queryResult.report_details
                var paymentSummary = []
                if(this.posCashierAccountability.length > 0){
                    var doc = new jsPDF({ orientation: 'landscape' });
                    // let reportLogo = document.getElementById('reportLogo');
                    // doc.addImage(reportLogo, "PNG", 15, 0, 15, 15);
                    for(var i= 0; i < this.posCashierAccountability.length; i++){
                        paymentSummary = (queryResult.payment_summary.length > 0) ? queryResult.payment_summary[i] : [];

                        // Gross Sales
                        var reportData = []
                        var reportDataFooter = []
                        // Deductions
                        var reportData2 = []
                        var reportData2Footer = []
                        // VAT Adjustments
                        var reportData3 = []
                        var reportData3Footer = []
                        // Totals
                        var reportData4 = []
                        // Other Income
                        var reportData5 = []
                        var reportData5Footer = []
                        // Amount In Drawer
                        var reportData6 = []
                        var reportData6Footer = []
                        // Payment Summary
                        var reportData7 = []
                        var reportData7Footer = []

                        if(i > 0 ){
                            doc.addPage();
                        }

                        var reportLine = this.posCashierAccountability[i]
                        reportData.push(["VATABLE SALES", formatNumber(parseFloat(Number(reportLine.vatable_sales)).toFixed(2))] )
                        reportData.push(["VAT AMOUNT", formatNumber(parseFloat(Number(reportLine.vat_amount)).toFixed(2))] )
                        reportData.push(["VAT-EXEMPT SALES", formatNumber(parseFloat(Number(reportLine.vat_exempt_sales)).toFixed(2))] )
                        reportData.push(["ZERO-RATED SALES", formatNumber(parseFloat(Number(reportLine.zero_rated_sales)).toFixed(2))] )
                        reportData.push(["", "----------------------------------------------"])
                        reportDataFooter.push(["GROSS SALES", formatNumber(parseFloat(Number(reportLine.gross_sales)).toFixed(2))])


                        reportData2.push(["REGULAR DISCOUNTS", formatNumber(parseFloat(Number(reportLine.regular_discount)).toFixed(2))] )
                        reportData2.push(["SPECIAL 5% DISCOUNTS", formatNumber(parseFloat(Number(reportLine.special_5)).toFixed(2))] )
                        reportData2.push(["SPECIAL 20% DISCOUNTS", formatNumber(parseFloat(Number(reportLine.special_20)).toFixed(2))] )
                        reportData2.push(["RETURNS", formatNumber(parseFloat(Number(reportLine.returns)).toFixed(2))] )
                        reportData2.push(["VOIDS", formatNumber(parseFloat(Number(reportLine.voids)).toFixed(2))] )
                        reportData2.push(["MANUAL", formatNumber(parseFloat(Number(reportLine.manual)).toFixed(2))] )
                        reportData2.push(["", "----------------------------------------------"])
                        reportData2Footer.push(["DEDUCTIONS",  formatNumber(parseFloat(Number(reportLine.deductions)).toFixed(2))])

                        reportData3.push(["REGULAR DISCOUNTS", formatNumber(parseFloat(Number(reportLine.va_regular_discount)).toFixed(2))] )
                        reportData3.push(["SPECIAL 5% DISCOUNTS", formatNumber(parseFloat(Number(reportLine. va_special_5)).toFixed(2))] )
                        reportData3.push(["SPECIAL 20% DISCOUNTS", formatNumber(parseFloat(Number(reportLine.va_special_20)).toFixed(2))] )
                        reportData3.push(["RETURNS", formatNumber(parseFloat(Number(reportLine.va_returns)).toFixed(2))] )
                        reportData3.push(["VOIDS", formatNumber(parseFloat(Number(reportLine.va_voids)).toFixed(2))] )
                        reportData3.push(["MANUAL", formatNumber(parseFloat(Number(reportLine.va_manual)).toFixed(2))] )
                        reportData3.push(["", "----------------------------------------------"])
                        reportData3Footer.push(["VAT ADJUSTMENTS",  formatNumber(parseFloat(Number(reportLine.va_total)).toFixed(2))])

                        reportData4.push(["NET SALES", formatNumber(parseFloat(Number(reportLine.net_sales)).toFixed(2))] )
                        reportData4.push(["NET VAT AMOUNT", formatNumber(parseFloat(Number(reportLine.net_vat_amount)).toFixed(2))] )
                        reportData4.push(["TOTAL QUANTITY", formatNumber(parseFloat(Number(reportLine.total_quantity)).toFixed(2))] )

                        reportData5.push(["EXCESS GC", formatNumber(parseFloat(Number(reportLine.excess_gc)).toFixed(2))] )
                        reportData5.push(["EXCESS RS", formatNumber(parseFloat(Number(reportLine.excess_rs)).toFixed(2))] )
                        reportData5.push(["", "----------------------------------------------"])
                        reportData5Footer.push(["OTHER INCOME",  formatNumber(parseFloat(Number(reportLine.other_income_total)).toFixed(2))])

                        reportData6.push(["+ DEPOSIT", formatNumber(parseFloat(Number(reportLine.deposit)).toFixed(2))] )
                        reportData6.push(["+ PAYMENTS", formatNumber(parseFloat(Number(reportLine.payments)).toFixed(2))] )
                        reportData6.push(["- WITHDRAWAL", formatNumber(parseFloat(Number(reportLine.withdrawal)).toFixed(2))] )
                        reportData6.push(["", "----------------------------------------------"])
                        reportData6Footer.push(["AMOUNT IN DRAWER",  formatNumber(parseFloat(Number(reportLine.amount_in_drawer)).toFixed(2))])

                        if(paymentSummary.length > 0){
                            var paymentSummaryKeys = JSON.parse(paymentSummary.tags)
                            var paymentSummaryValues = JSON.parse(paymentSummary.data)
                            for(var y=0; y < paymentSummaryKeys.length; y++){
                                var INVALID_TAGS = ["gcExcess", "rsExcess", "total", "cashCount", "chargeCount", "couponCount", "debitSummary", "creditSummary", "gcExcessCount", "rsExcessCount", "debitCardCount", "creditCardCount", "creditMemoCount", "rewardPointCount", "giftCertificateCount"]
                                var hashKey = paymentSummaryKeys[y]
                                var label = _.upperCase(hashKey)
                                if(!INVALID_TAGS.includes(hashKey)){
                                    reportData7.push([label, formatNumber(paymentSummaryValues[hashKey].toFixed(2))] )
                                    if(hashKey == "creditMemo")
                                        reportData7.push(["         RS EXCESS", formatNumber(paymentSummaryValues["rsExcess"].toFixed(2))] )
                                    else if (hashKey == "giftCertificate")
                                        reportData7.push(["         GC EXCESS", formatNumber(paymentSummaryValues["gcExcess"].toFixed(2))] )

                                }
                            }
                            reportData7.push(["", "----------------------------------------------"])
                            reportData7Footer.push(["PAYMENT SUMMARY",  formatNumber(paymentSummaryValues["total"].toFixed(2))])
                        }


                        var startingPage = doc.internal.getCurrentPageInfo().pageNumber;

                        doc.setFontSize(14);
                        doc.setFontType("bold");
                        doc.text(15,20,"POS Cashier Accountability Report ")
                        doc.setFontType("normal");
                        doc.setFontSize(10);
                        doc.text(15,25,"Site: " + reportLine.site_name)
                        doc.text(15,30,"From " +  this.searchDateFrom + " to " + this.searchDateTo)
                        doc.text(15,35,"Cashier: " + reportLine.cashier_name)

                        doc.autoTable(
                                {
                                    startY: 45,
                                    body: reportData,
                                    theme: 'plain',
                                    tableWidth: 'wrap',
                                    avoidPageSplit: true,
                                    columnStyles: {
                                        0: {cellWidth: 80},
                                        1: {halign: "right", cellWidth: 40}
                                    },
                                    styles: {
                                        cellPadding: 0.5, fontSize: 7
                                    },
                                }
                        )

                        doc.autoTable(
                                {
                                    startY: 65,
                                    body: reportDataFooter,
                                    theme: 'plain',
                                    tableWidth: 'wrap',
                                    avoidPageSplit: true,
                                    margin: {left: 75},
                                    columnStyles: {
                                        0: {cellWidth: 40},
                                        1: {halign: "right", cellWidth: 20}
                                    },
                                    styles: {
                                        cellPadding: 0.5, fontSize: 7, fontStyle: "bold"
                                    },
                                }
                        )

                        doc.autoTable(
                                {
                                    startY: 75,
                                    body: reportData2,
                                    theme: 'plain',
                                    tableWidth: 'wrap',
                                    avoidPageSplit: true,
                                    columnStyles: {
                                        0: {cellWidth: 80},
                                        1: {halign: "right", cellWidth: 40}
                                    },
                                    styles: {
                                        cellPadding: 0.5, fontSize: 7
                                    },
                                }
                        )

                        doc.autoTable(
                                {
                                    startY: 103,
                                    body: reportData2Footer,
                                    theme: 'plain',
                                    tableWidth: 'wrap',
                                    margin: {left: 75},
                                    avoidPageSplit: true,
                                    columnStyles: {
                                        0: {cellWidth: 40},
                                        1: {halign: "right", cellWidth: 20}
                                    },
                                    styles: {
                                        cellPadding: 0.5, fontSize: 7, fontStyle: "bold"
                                    },
                                }
                        )

                        doc.autoTable(
                                {
                                    startY: 113,
                                    body: reportData3,
                                    theme: 'plain',
                                    tableWidth: 'wrap',
                                    avoidPageSplit: true,
                                    columnStyles: {
                                        0: {cellWidth: 80},
                                        1: {halign: "right", cellWidth: 40}
                                    },
                                    styles: {
                                        cellPadding: 0.5, fontSize: 7
                                    },
                                }
                        )

                        doc.autoTable(
                                {
                                    startY: 141,
                                    body: reportData3Footer,
                                    theme: 'plain',
                                    tableWidth: 'wrap',
                                    avoidPageSplit: true,
                                    margin: {left: 75},
                                    columnStyles: {
                                        0: {cellWidth: 40},
                                        1: {halign: "right", cellWidth: 20}
                                    },
                                    styles: {
                                        cellPadding: 0.5, fontSize: 7, fontStyle: "bold"
                                    },
                                }
                        )

                        doc.autoTable(
                                {
                                    startY: 151,
                                    body: reportData4,
                                    theme: 'plain',
                                    tableWidth: 'wrap',
                                    avoidPageSplit: true,
                                    columnStyles: {
                                        0: {cellWidth: 80},
                                        1: {halign: "right", cellWidth: 40}
                                    },
                                    styles: {
                                        cellPadding: 0.5, fontSize: 7, fontStyle: "bold"
                                    },
                                }
                        )

                        doc.autoTable(
                                {
                                    startY: 45,
                                    body: reportData5,
                                    theme: 'plain',
                                    tableWidth: 'wrap',
                                    margin: {left: 150},
                                    avoidPageSplit: true,
                                    columnStyles: {
                                        0: {cellWidth: 80},
                                        1: {halign: "right", cellWidth: 40}
                                    },
                                    styles: {
                                        cellPadding: 0.5, fontSize: 7
                                    },
                                }
                        )

                        doc.autoTable(
                                {
                                    startY: 58,
                                    body: reportData5Footer,
                                    theme: 'plain',
                                    tableWidth: 'wrap',
                                    avoidPageSplit: true,
                                    margin: {left: 210},
                                    columnStyles: {
                                        0: {cellWidth: 40},
                                        1: {halign: "right", cellWidth: 20}
                                    },
                                    styles: {
                                        cellPadding: 0.5, fontSize: 7, fontStyle: "bold"
                                    },
                                }
                        )

                        doc.autoTable(
                                {
                                    startY: 75,
                                    body: reportData6,
                                    theme: 'plain',
                                    tableWidth: 'wrap',
                                    avoidPageSplit: true,
                                    margin: {left: 150},
                                    columnStyles: {
                                        0: {cellWidth: 80},
                                        1: {halign: "right", cellWidth: 40}
                                    },
                                    styles: {
                                        cellPadding: 0.5, fontSize: 7
                                    },
                                }
                        )

                        doc.autoTable(
                                {
                                    startY: 91,
                                    body: reportData6Footer,
                                    theme: 'plain',
                                    tableWidth: 'wrap',
                                    margin: {left: 210},
                                    avoidPageSplit: true,
                                    columnStyles: {
                                        0: {cellWidth: 40},
                                        1: {halign: "right", cellWidth: 20}
                                    },
                                    styles: {
                                        cellPadding: 0.5, fontSize: 7, fontStyle: "bold"
                                    },
                                }
                        )

                        doc.autoTable(
                                {
                                    startY: 113,
                                    body: reportData7,
                                    theme: 'plain',
                                    margin: {left: 150},
                                    tableWidth: 'wrap',
                                    avoidPageSplit: true,
                                    columnStyles: {
                                        0: {cellWidth: 80},
                                        1: {halign: "right", cellWidth: 40}
                                    },
                                    styles: {
                                        cellPadding: 0.5, fontSize: 7
                                    },
                                }
                        )

                        doc.autoTable(
                                {
                                    startY: 156,
                                    body: reportData7Footer,
                                    theme: 'plain',
                                    tableWidth: 'wrap',
                                    margin: {left: 210},
                                    avoidPageSplit: true,
                                    columnStyles: {
                                        0: {cellWidth: 40},
                                        1: {halign: "right", cellWidth: 20}
                                    },
                                    styles: {
                                        cellPadding: 0.5, fontSize: 7, fontStyle: "bold"
                                    },
                                }
                        )


                        doc.setFontSize(8);
                        doc.text(15,195,"Printed By: " + secureStorage.getItem("email"))
                        doc.text(270,195,"POS Cashier Accountability Report", "right")
                        doc.text(15,200,"Print Date: " + moment().format(this.dateFormat2))
                        doc.text(270,200,"Page " + ( i + 1)  + " of " + this.posCashierAccountability.length, "right")

                    }
                } else {
                  this.openNotificationWithIcon('warning', 'Try increasing the scope by adjusting the filters.');
                }
                // console.log(this.posCashierAccountability)
                this.spinning= false;
                // doc.output('dataurlnewwindow');
                window.open(URL.createObjectURL(doc.output("blob")))

        },

        }
    };
</script>

<style></style>
